import { render, staticRenderFns } from "./point-fire.vue?vue&type=template&id=433b0a4b&"
import script from "./point-fire.vue?vue&type=script&lang=js&"
export * from "./point-fire.vue?vue&type=script&lang=js&"
import style0 from "./point-fire.vue?vue&type=style&index=0&id=433b0a4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports